(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ff-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    const countdowns = document.querySelectorAll('.ff-countdown[data-countdown-date]');
    countdowns.forEach(function (el) {
      const targetDate = new Date(el.dataset.countdownDate).getTime();
      if (isNaN(targetDate)) return;

      const daysEl    = el.querySelector('[data-countdown-days]');
      const hoursEl   = el.querySelector('[data-countdown-hours]');
      const minutesEl = el.querySelector('[data-countdown-minutes]');
      const secondsEl = el.querySelector('[data-countdown-seconds]');

      function updateText(container, value) {
        const textEl = container && container.querySelector('.ff-snippet-text');
        if (textEl) textEl.textContent = value;
      }

      function update() {
        const diff = Math.max(0, targetDate - Date.now());
        const pad  = function (n) { return String(n).padStart(2, '0'); };

        updateText(daysEl,    pad(Math.floor(diff / 86400000)));
        updateText(hoursEl,   pad(Math.floor((diff % 86400000) / 3600000)));
        updateText(minutesEl, pad(Math.floor((diff % 3600000)  / 60000)));
        updateText(secondsEl, pad(Math.floor((diff % 60000)    / 1000)));

        if (diff <= 0) clearInterval(timer);
      }

      update();
      var timer = setInterval(update, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
